import {
  Activity,
  ArrowRight,
  Calculator,
  History,
  Inbox,
  MessagesSquare,
  Users,
} from "lucide-react";
import { Eyebrow, Item, Reveal, Stagger } from "../components/Reveal";
import { useLeadModal } from "../components/LeadModal";

const CARDS = [
  { icon: Inbox, title: "Gestão de chamados", text: "Centralização das solicitações e demandas." },
  { icon: Calculator, title: "Orçamentos", text: "Organização e acompanhamento dos orçamentos." },
  { icon: Users, title: "Prestadores", text: "Acionamento e gerenciamento dos profissionais." },
  { icon: Activity, title: "Acompanhamento", text: "Controle de cada etapa da demanda." },
  { icon: MessagesSquare, title: "Comunicação", text: "Informações organizadas para todos os envolvidos." },
  { icon: History, title: "Histórico", text: "Registro das solicitações e serviços realizados." },
];

export const ForAgencies = () => {
  const { openModal } = useLeadModal();

  return (
    <section
      id="imobiliarias"
      className="relative overflow-hidden bg-slate-100/60 py-24 lg:py-32"
      data-testid="agencies-section"
    >
      <div className="glow-brand pointer-events-none absolute -right-40 top-0 h-[420px] w-[420px] rounded-full" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid items-end gap-8 lg:grid-cols-[1.2fr_auto]">
          <Reveal>
            <Eyebrow>Para imobiliárias e administradoras</Eyebrow>
            <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-petrol sm:text-3xl lg:text-4xl">
              Sua imobiliária não precisa <span className="text-brand">cuidar de tudo.</span>
            </h2>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-600">
              A Resolv assume a operação das demandas relacionadas aos imóveis, permitindo que
              sua equipe tenha mais tempo para cuidar do que realmente importa: clientes,
              locações e negócios.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <button
              onClick={() => openModal("", "agency")}
              data-testid="agencies-cta-button"
              className="group inline-flex h-12 items-center gap-2 whitespace-nowrap rounded-full bg-petrol px-7 text-sm font-semibold text-white transition-colors duration-300 hover:bg-brand"
            >
              Quero levar a Resolv para minha imobiliária
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </Reveal>
        </div>

        <Stagger className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {CARDS.map((card) => (
            <Item
              key={card.title}
              data-testid={`agency-card-${card.title.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="group flex h-full items-start gap-5 rounded-2xl border border-slate-200/80 bg-white p-6 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:border-brand/40 hover:shadow-[0_24px_48px_-20px_rgba(0,102,255,0.25)]">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand/10 text-brand transition-colors duration-300 group-hover:bg-brand group-hover:text-white">
                  <card.icon className="h-5 w-5" strokeWidth={1.9} />
                </span>
                <div>
                  <h3 className="font-display text-base font-semibold text-petrol">{card.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{card.text}</p>
                </div>
              </div>
            </Item>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
